import { createAction, props } from '@ngrx/store';
import { IAddProductSolution } from '../models/product-solutions.model';

export const loadAddProductSolutions = createAction(
  '[AddProductSolutions] Load AddProductSolutions',
  props<{ request: IAddProductSolution }>()
);

export const loadAddProductSolutionssSucces = createAction(
  '[AddProductSolutions] Load AddProductSolutions Success',
  props<{ response: string }>()
);

export const loadAddProductSolutionssFailure = createAction(
  '[AddProductSolutions] Load AddProductSolutions Failure',
  props<{ error: Error | any }>()
);
